:host {
  display: contents;
}
